:host {
  display: contents;
}
